import { thor } from "../../typings/thor";

export class SortTableBtnController {
    // Binded
    public sortParams: thor.SortParams;
    public sortType: thor.SortType;

    public sort() {
        this.sortParams.reverse = this.sortParams.field === this.sortType.field ? !this.sortParams.reverse : false;
        this.sortParams.field = this.sortType.field;
    }
}
